import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]

import {
  projectName,
  projectNames,
} from '@/shared/constants/system';
import BaseCard from '@/shared/lib/uikit/components/BaseCard/BaseCard.vue';
import BaseDialog from '@/shared/lib/uikit/components/BaseDialog/BaseDialog.vue';
import {
  computed,
  ref,
} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsAppUnavailable',
  setup(__props) {

const opened = ref(false);

const link = computed(() => (projectName === projectNames.MTI ? 'https://t.me/mti_mc' : 'https://t.me/mteam_supp'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      onClickCapture: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (opened.value=true), ["stop","prevent"]))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 32),
    _createVNode(BaseDialog, {
      modelValue: opened.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((opened).value = $event)),
      close: "",
      "content-width": "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(BaseCard, { class: "m_pa16 m_bg-white m_flex m_flex-column m_flex-grow1 m_hov-elevation-1 m_hov-border-none" }, {
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createTextVNode(" В связи с временными ограничениями в работе WhatsApp, просим направлять ваши обращения через ")),
            _createElementVNode("a", {
              href: link.value,
              target: "_blank",
              rel: "noopener noreferrer"
            }, " Telegram ", 8, _hoisted_1),
            _cache[3] || (_cache[3] = _createTextVNode(" или в нашу ")),
            _createElementVNode("a", {
              href: _ctx.isMTI ? 'mailto:help@moicapital.ru' : 'mailto:help@synergyfriends.ru'
            }, "техническую поддержку", 8, _hoisted_2)
          ]),
          _: 1,
          __: [2,3]
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})